import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import i18n from 'i18next';
import {
  hashKey,
  getSupportedLanguages,
  getWhitelistedLanguages,
} from 'core/i18n';

const blacklistedLanguages = ['fr'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'en',
    ns: ['translations', 'labels'],
    defaultNS: 'translations',
    nsSeparator: false,
    contextSeparator: '|',
    debug: false,
    supportedLngs: getSupportedLanguages().filter(
      language => !blacklistedLanguages.includes(language),
    ),
    nonExplicitWhitelist: getWhitelistedLanguages().filter(
      language => !blacklistedLanguages.includes(language),
    ),
    backend: {
      loadPath: ([lng], [ns]) =>
        `${STATIC_URL_BASE}/locales/${lng?.substring(0, 2)}/${ns}.json`,
      queryStringParams: { v: LOCALES_VERSION },
      crossDomain: true,
    },
    interpolation: { escapeValue: false },
    react: { wait: true },
  });

i18n.T = i18n.t.bind(i18n);

// eslint-disable-next-line
i18n.t = function(key, options = {}) {
  options.defaultValue = key;
  const hKey = hashKey(key);
  return i18n.T(hKey, options);
};

export { i18n };
